import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/app/.nuxt/pwa-icons-plugin.ts";
import pwa_client_Eorgdr12jA from "/app/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.mjs";
import plugin_client_4F1kZh3YAB from "/app/node_modules/nuxt-viewport/dist/runtime/plugin.client.js";
import plugin_ghbUAjaD3n from "/app/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_AUP22rrBAc from "/app/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import ui_ripple_Hxkzo3oZQ4 from "/app/node_modules/@smenaspace/ui-layer/plugins/ui-ripple.ts";
import _00_providePipelineId_0JEWp9uWvs from "/app/node_modules/@smenaspace/settings-layer/plugins/00.providePipelineId.ts";
import _01_initHost_kvzUqqVj3x from "/app/node_modules/@smenaspace/settings-layer/plugins/01.initHost.ts";
import _02_initSentry_client_8Zg5aLlnyS from "/app/node_modules/@smenaspace/settings-layer/plugins/02.initSentry.client.ts";
import _02_initApiModule_a5VDYmFRzk from "/app/plugins/02.initApiModule.ts";
import _04_initCityInfo_1x5Wzz5SiL from "/app/plugins/04.initCityInfo.ts";
import _06_routers_yD51MPPROY from "/app/plugins/06.routers.ts";
import _07_initToggleStore__ALvc7JczYZ from "/app/plugins/07.initToggleStore..ts";
import _08_initUserInfo_client_ttZDKBFMR7 from "/app/plugins/08.initUserInfo.client.ts";
import _09_errorHandler_ufAOD8hmRo from "/app/plugins/09.errorHandler.ts";
import _09_initServiceMetrics_client_OqnTS8sKC6 from "/app/plugins/09.initServiceMetrics.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_Eorgdr12jA,
  plugin_client_4F1kZh3YAB,
  plugin_ghbUAjaD3n,
  plugin_AUP22rrBAc,
  ui_ripple_Hxkzo3oZQ4,
  _00_providePipelineId_0JEWp9uWvs,
  _01_initHost_kvzUqqVj3x,
  _02_initSentry_client_8Zg5aLlnyS,
  _02_initApiModule_a5VDYmFRzk,
  _04_initCityInfo_1x5Wzz5SiL,
  _06_routers_yD51MPPROY,
  _07_initToggleStore__ALvc7JczYZ,
  _08_initUserInfo_client_ttZDKBFMR7,
  _09_errorHandler_ufAOD8hmRo,
  _09_initServiceMetrics_client_OqnTS8sKC6
]